import { FilterBloc } from './filter_bloc/FilterBloc';
import { createToken } from '@core/utils/ioc';
import { ActivityBloc } from './activity_bloc';
import { BoardBloc } from './board_bloc';
import { BrandBloc } from './brand_bloc';
import { CannedBloc } from './canned_bloc/CannedBloc';
import { CategoryBloc } from './category_bloc';
import { ChangelogBloc } from './changelog_bloc';
import { ChannelSenderBloc } from './channel_sender_bloc';
import { ChecklistBloc } from './checklist_bloc';
import { ChecklistTemplateBloc } from './checklist_template_bloc';
import { ChildChecklistBloc } from './child_checklist_bloc';
import { ClientFormBloc } from './client_form_bloc';
import { ClientProjectBloc } from './client_project_bloc';
import { CommentBloc } from './comment_bloc';
import { CommissionBloc } from './commission_bloc/CommissionBloc';
import { CompanyBloc } from './company_bloc';
import { CompanyStatsBloc } from './company_stats_bloc';
import { ContactBloc } from './contact_bloc';
import { CourseBloc } from './course_bloc';
import { DashboardBloc } from './dashboard_bloc';
import { DealBloc } from './deal_bloc';
import { DealBoardBloc } from './deal_board_bloc';
import { DealLostReasonBloc } from './deal_lost_reason_bloc';
import { DealStageBloc } from './deal_stage_bloc/DealStageBloc';
import { DealConfidenceLevelBloc } from './deal_confidence_level_bloc/DealConfidenceLevelBloc';
import { DealStatusBloc } from './deal_status_bloc/DealStatusBloc';
import { DealDisqualificationRuleBloc } from './deal_disqualification_rule_bloc/DealDisqualificationRuleBloc';
import { DealStatusStageMappingBloc } from './deal_status_stage_mapping_bloc/DealStatusStageMappingBloc';
import { DynamincReportBloc } from './dynaminc_report_bloc';
import { EchoBloc } from './echo_bloc';
import { EmailBloc } from './email_bloc/EmailBloc';
import { FileBloc } from './file_bloc/FileBloc';
import { FormBloc } from './form_bloc';
import { GlossaryBloc } from './glossary_bloc';
import { HelpArticleBloc } from './help_article_bloc';
import { HelpArticleCategoryBloc } from './help_article_category_bloc';
import { HelpArticleTagBloc } from './help_article_tag_bloc';
import { IdeaBloc } from './idea_bloc';
import { IntegrationBloc } from './integration_bloc';
import { InvoiceSettingBloc } from './invoice_setting_bloc';
import { JobBloc } from './job_bloc';
import { KnowledgeBaseBloc } from './knowledge_base_bloc';
import { LibraryBloc } from './library_bloc/LibraryBloc';
import { LineUpBloc } from './lineup_bloc';
import { LogBloc } from './log_bloc';
import { MarketingBoardBloc } from './marketing_board_bloc';
import { MarketingChecklistBloc } from './marketing_checklist_bloc';
import { MediaBloc } from './media_bloc';
import { OrderActivityBloc } from './order_activity_bloc/OrderActivityBloc';
import { OrderBloc } from './order_bloc/OrderBloc';
import { OrderProductBloc } from './order_product_bloc';
import { PurchaseOrderBloc } from './order_purchase_bloc/PurchaseOrderBloc';
import { OrderStageBloc } from './order_stage_bloc';
import { OrderTermBloc } from './order_term_bloc';
import { OrderVendorBloc } from './order_vendor_bloc';
import { OrganizationBloc } from './organization_bloc';
import { PricingTeirBloc } from './pricing_tier_bloc';
import { ProjectBloc } from './project_bloc';
import { ProjectPriorityBloc } from './project_priority_bloc';
import { ProjectStageBloc } from './project_stage_bloc';
import { ProjectTemplateBloc } from './project_template_bloc';
import { PublicFormBloc } from './public_form_bloc';
import { ReportBloc } from './report_bloc/ReportBloc';
import { ReportCategoryBloc } from './report_category_bloc';
import { ReportSourceBloc } from './report_source_bloc/ReportSourceBloc';
import { RingCentralBloc } from './ringcentral_bloc';
import { SenderBloc } from './sender_bloc';
import { ServiceBloc } from './service_bloc';
import { ServiceClassBloc } from './service_class_bloc';
import { SettingsBloc } from './settings_bloc';
import { SharedProjectBloc } from './shared_project_bloc';
import { StoreBloc } from './store_bloc';
import { SupportCategoriesBloc } from './support_categories_bloc';
import { SupportChannelAssignBloc, SupportChannelBloc, SupportChannelRuleBloc } from './support_channel_bloc';
import { SupportTicketBloc } from './support_ticket_bloc';
import { TagBloc } from './tag_bloc';
import { TaskBloc } from './task_bloc';
import { TeamBloc } from './team_bloc';
import { TimeLogBloc } from './time_log_bloc';
import { TodoBloc } from './todo_bloc';
import { TodoChecklistBloc } from './todo_checklist_bloc';
import { UserBloc } from './user_bloc';
import { UserCourseBloc } from './user_course_bloc';
import { WebhookBloc } from './webhook_bloc';
import { ApiKeyBloc } from './apikey_bloc';
import { PreviewCourseBloc } from './preview_course_bloc';
import { IntegrationHelperBloc } from './integration_helper_bloc';
import { SubscriptionBoardBloc } from './subscription_board_bloc';
import { CurrencyBloc } from './currency_bloc';
import { DashboardEmailBloc } from './dashboard_emails_bloc';
import { CommissionGroupBloc } from './commission_group_bloc';
import { CommissionPeriodBloc } from './commission_period_bloc';
import { MarketingBoardBloc as MarketingBoardBlocV2 } from './marketing_board_bloc_v2';
import { ProposalTemplateBloc } from './proposal_template_bloc';
import { ProposalTemplateFolderBloc } from './proposal_template_folder_bloc';
import { ProposalBloc } from './proposal_bloc';
import { OrderPackageBloc } from './order_package_bloc';
import { TmStageBloc } from './tm_stage_bloc';
import { TimeMaterialBloc } from './time_material_bloc';
import { TimeMaterialActivityBloc } from './time_material_activity_bloc';
import { LabourTypeBloc } from './labour_type_bloc';
import { TMTimeTrackingBloc } from './tm_time_tracking/TMTimeTrackingBloc';
import { TMReceivedProductBloc } from './tm_received_product/TMReceivedProductBloc';
import { TaskStatusBloc } from './task_statuses';
import { BlockTemplateBloc } from './block_template_bloc';
import { AuthBloc } from './auth_bloc';
import { TimeMaterialBoardBloc } from './tm_board_bloc';
import { ManagementFormBloc } from './management_form_bloc';
import { ManagementFormTemplateBloc } from './management_form_template_bloc';
import { SharedFileBloc } from './shared_file_bloc';
import { TmPhaseBloc } from './tm_phase_bloc';
import { CalendarBloc } from './calendar_bloc';
import { TMChangeOrderBoardBloc } from './tm_change_order_board_bloc';
import { TMChangeOrderBloc } from './tm_change_order_bloc';
import { DiscountTypeBloc } from './discount_type_bloc/DiscountTypeBloc';
import { TMChangeOrderTypeBloc } from './tm_change_order_type_bloc';
import { CommissionTypeBloc } from './commission_type_bloc/CommissionTypeBloc';
import { ClockinBloc } from './clockin_bloc';
import { TMFeeBloc } from './tm_fee_bloc';
import { ClockinReportsBloc } from './clockin_reports_bloc/ClockinReportsBloc';
import { TMRMADamageStatusBloc } from './tm_rma_damage_status_bloc';
import { TmRMABloc } from './tm_rma_bloc';
import { PoStatusBloc } from './po_status_bloc';
import { ARDashboardBloc } from './ardashboard_bloc';
import { OrderBrandBloc } from './order_brand_bloc';
import { SupportTaskBloc } from './support_task_bloc';
import { LibraryDocumentBloc } from './library_document_bloc';
import { CourseInboxBloc } from './instructor_inbox_bloc';
import { CourseInboxReplyBloc } from './course_inbox_reply_bloc';
import { TimeoffBloc } from './timeoff_bloc';
import { AutomationBloc } from './automation_bloc';
import { PresentationBloc } from './presentation_bloc';
import { OvertimeBloc } from './overtime_bloc';
import { EstimatorTempateBloc } from './tm_estimator_template_bloc/EstimatorTempateBloc';
import { EstimatorTemplateListBloc } from './estimator_template_list_bloc';
import { TmAgreementBloc } from './tm_agreement_bloc';
import { TMEstimatorTemplateFeeBloc } from './tm_estimator_template_fee_bloc';
import { EstimateBloc } from './estimate_bloc';
import { RegionBloc } from './tm_region_bloc';
import { ServiceProvidersBloc } from './tm_service_provider_bloc';
import { SubContractorBloc } from './subcontractor_bloc';
import { SubContractorCategoryFormBloc } from './subcontractor_category_form_bloc';
import { SubContractorEmailTemplateBloc } from './subcontractor_email_template_bloc';
import { EventBloc } from './events_bloc';
import { SystemCalendarBloc } from '@business/blocs/system_calendar_bloc';
import { CalendarTemplateBloc } from '@business/blocs/calendar_template_bloc';
import { CalendarTemplateEventBloc } from '@business/blocs/calendar_template_events_bloc';
import { CompanyHolidayBloc } from '@business/blocs/company_holiday_bloc';
import { CustomTabBloc } from './custom_tab_bloc';
import { EventCommentBloc } from './event_comments_bloc';
import { TemplateBloc } from './template_bloc';
import { InvoiceScheduleBloc } from './invoice_schedule_bloc';
import { TMInvoiceScheduleBloc } from './tm_invoice_schedule_bloc';
import { TMProviderInvoiceBloc } from './tm_provider_invoice_bloc';
import { TMVendorInvoiceBloc } from './tm_vendor_invoice_bloc';
import { TMGroupNotesBloc } from './tm_group_notes_bloc';
import { TMFeeNotesBloc } from './tm_fee_notes_bloc';
import { TMTemplateBloc } from '@business/blocs/tm_template_bloc';
import { FileFormBloc } from '@business/blocs/file_form_bloc';
import { NotificationBloc } from './notification_bloc';
import { RollupBloc } from './tm_rollup_bloc';
import { CategoryOptionBloc } from './category_option_bloc';
import { JobTypeBloc } from './tm_job_type_bloc';
import { EstimateV2Bloc } from './estimatev2_bloc/EstimateV2Bloc';
import { SystemFileBloc } from '@business/blocs/system_files_bloc';
import { CommissionOverrideBloc } from './commission_override_bloc';
import { JournalBloc } from './journal_bloc';
import { FeedbackBloc } from './feedback_bloc';
import { TMProviderInvoiceItemBloc } from './tm_provider_invoice_item_bloc';
import { CustomerDashboardColumnStatusBloc } from './customer_dashboard_column_status_bloc';
import { EstimateListBloc } from './estimate_list_bloc';

export const Blocs = {
  compnay: createToken<CompanyBloc>(),
  brand: createToken<BrandBloc>(),
  user: createToken<UserBloc>(),
  organization: createToken<OrganizationBloc>(),
  settings: createToken<SettingsBloc>(),
  contact: createToken<ContactBloc>(),
  contactActivity: createToken<ActivityBloc>(),
  service: createToken<ServiceBloc>(),
  serviceClass: createToken<ServiceClassBloc>(),
  project: createToken<ProjectBloc>(),
  board: createToken<BoardBloc>(),
  integration: createToken<IntegrationBloc>(),
  projectTemplate: createToken<ProjectTemplateBloc>(),
  projectStage: createToken<ProjectStageBloc>(),
  projectPriority: createToken<ProjectPriorityBloc>(),
  checklist: createToken<MarketingChecklistBloc>(),
  marketingBoard: createToken<MarketingBoardBloc>(),
  file: createToken<FileBloc>(),
  deal: createToken<DealBloc>(),
  dealBoard: createToken<DealBoardBloc>(),
  dealStage: createToken<DealStageBloc>(),
  dealLostReason: createToken<DealLostReasonBloc>(),
  dealConfidenceLevel: createToken<DealConfidenceLevelBloc>(),
  dealStatus: createToken<DealStatusBloc>(),
  dealDisqualificationRule: createToken<DealDisqualificationRuleBloc>(),
  dealStatusStageMapping: createToken<DealStatusStageMappingBloc>(),
  form: createToken<FormBloc>(),
  subcontractorcategoryform: createToken<SubContractorCategoryFormBloc>(),
  supportCategory: createToken<SupportCategoriesBloc>(),
  supportChannel: createToken<SupportChannelBloc>(),
  supportChannelAssign: createToken<SupportChannelAssignBloc>(),
  supportChannelRule: createToken<SupportChannelRuleBloc>(),
  supportTicket: createToken<SupportTicketBloc>(),
  helpArticle: createToken<HelpArticleBloc>(),
  helpArticleCategory: createToken<HelpArticleCategoryBloc>(),
  helpArticleTag: createToken<HelpArticleTagBloc>(),
  echo: createToken<EchoBloc>(),
  report: createToken<ReportBloc>(),
  canned: createToken<CannedBloc>(),
  timeLog: createToken<TimeLogBloc>(),
  clientProject: createToken<ClientProjectBloc>(),
  sender: createToken<SenderBloc>(),
  channelSender: createToken<ChannelSenderBloc>(),
  ringcentral: createToken<RingCentralBloc>(),
  log: createToken<LogBloc>(),
  email: createToken<EmailBloc>(),
  media: createToken<MediaBloc>(),
  team: createToken<TeamBloc>(),
  dashboard: createToken<DashboardBloc>(),
  publicForm: createToken<PublicFormBloc>(),
  clientForm: createToken<ClientFormBloc>(),
  comment: createToken<CommentBloc>(),
  task: createToken<TaskBloc>(),
  knowledgeBase: createToken<KnowledgeBaseBloc>(),
  invoiceSetting: createToken<InvoiceSettingBloc>(),
  subcontractorEmailTemplate: createToken<SubContractorEmailTemplateBloc>(),
  library: createToken<LibraryBloc>(),
  checklistTemplate: createToken<ChecklistTemplateBloc>(),
  todoChecklists: createToken<TodoChecklistBloc>(),
  course: createToken<CourseBloc>(),
  userCourse: createToken<UserCourseBloc>(),
  companyStats: createToken<CompanyStatsBloc>(),
  todoChecklist: createToken<ChecklistBloc>(),
  childTodoChecklist: createToken<ChildChecklistBloc>(),
  todo: createToken<TodoBloc>(),
  webhook: createToken<WebhookBloc>(),
  store: createToken<StoreBloc>(),
  orderStage: createToken<OrderStageBloc>(),
  orderTerm: createToken<OrderTermBloc>(),
  orderVendor: createToken<OrderVendorBloc>(),
  orderProduct: createToken<OrderProductBloc>(),
  order: createToken<OrderBloc>(),
  purchaseOrder: createToken<PurchaseOrderBloc>(),
  category: createToken<CategoryBloc>(),
  subcontractor: createToken<SubContractorBloc>(),
  pricingTeir: createToken<PricingTeirBloc>(),
  commission: createToken<CommissionBloc>(),
  commissionGroup: createToken<CommissionGroupBloc>(),
  orderActivity: createToken<OrderActivityBloc>(),
  idea: createToken<IdeaBloc>(),
  tag: createToken<TagBloc>(),
  sharedProject: createToken<SharedProjectBloc>(),
  job: createToken<JobBloc>(),
  glossary: createToken<GlossaryBloc>(),
  lineUp: createToken<LineUpBloc>(),
  reportCategory: createToken<ReportCategoryBloc>(),
  dynamincReport: createToken<DynamincReportBloc>(),
  apiKey: createToken<ApiKeyBloc>(),
  changelog: createToken<ChangelogBloc>(),
  previewCourse: createToken<PreviewCourseBloc>(),
  reportSource: createToken<ReportSourceBloc>(),
  integrationHelper: createToken<IntegrationHelperBloc>(),
  subscriptionBoard: createToken<SubscriptionBoardBloc>(),
  currency: createToken<CurrencyBloc>(),
  dashboardEmail: createToken<DashboardEmailBloc>(),
  commissionPeriod: createToken<CommissionPeriodBloc>(),
  marketingBoardV2: createToken<MarketingBoardBlocV2>(),
  proposalTemplate: createToken<ProposalTemplateBloc>(),
  template: createToken<TemplateBloc>(),
  proposalTemplateFolder: createToken<ProposalTemplateFolderBloc>(),
  proposal: createToken<ProposalBloc>(),
  orderPackage: createToken<OrderPackageBloc>(),
  tmStage: createToken<TmStageBloc>(),
  timeMaterial: createToken<TimeMaterialBloc>(),
  timeMaterialActivity: createToken<TimeMaterialActivityBloc>(),
  labourTypes: createToken<LabourTypeBloc>(),
  tmTimeTracking: createToken<TMTimeTrackingBloc>(),
  tmReceivedProduct: createToken<TMReceivedProductBloc>(),
  taskStatus: createToken<TaskStatusBloc>(),
  blockTemplate: createToken<BlockTemplateBloc>(),
  authBloc: createToken<AuthBloc>(),
  timeMaterialBoard: createToken<TimeMaterialBoardBloc>(),
  tmEstimatorTempate: createToken<EstimatorTempateBloc>(),
  estimatorTemplateList: createToken<EstimatorTemplateListBloc>(),
  tmAgreement: createToken<TmAgreementBloc>(),
  tmRegion: createToken<RegionBloc>(),
  tmServiceProvider: createToken<ServiceProvidersBloc>(),
  managementForm: createToken<ManagementFormBloc>(),
  managementFormTemplates: createToken<ManagementFormTemplateBloc>(),
  sharedFile: createToken<SharedFileBloc>(),
  timeMaterialPhase: createToken<TmPhaseBloc>(),
  calendar: createToken<CalendarBloc>(),
  tmChangeOrderBoard: createToken<TMChangeOrderBoardBloc>(),
  tmChangeOrder: createToken<TMChangeOrderBloc>(),
  discountType: createToken<DiscountTypeBloc>(),
  tmChangeOrderType: createToken<TMChangeOrderTypeBloc>(),
  commissionType: createToken<CommissionTypeBloc>(),
  clockin: createToken<ClockinBloc>(),
  tmFee: createToken<TMFeeBloc>(),
  tmEstimatorTemplateFee: createToken<TMEstimatorTemplateFeeBloc>(),
  clockinReport: createToken<ClockinReportsBloc>(),
  filter: createToken<FilterBloc>(),
  tmRMADamageStatus: createToken<TMRMADamageStatusBloc>(),
  tmRMA: createToken<TmRMABloc>(),
  poStatus: createToken<PoStatusBloc>(),
  arDashboard: createToken<ARDashboardBloc>(),
  orderBrand: createToken<OrderBrandBloc>(),
  supportTask: createToken<SupportTaskBloc>(),
  libraryDocument: createToken<LibraryDocumentBloc>(),
  courseInbox: createToken<CourseInboxBloc>(),
  courseInboxReply: createToken<CourseInboxReplyBloc>(),
  timeoff: createToken<TimeoffBloc>(),
  automation: createToken<AutomationBloc>(),
  presentation: createToken<PresentationBloc>(),
  overtime: createToken<OvertimeBloc>(),
  estimate: createToken<EstimateBloc>(),
  estimateV2: createToken<EstimateV2Bloc>(),
  events: createToken<EventBloc>(),
  systemCalendars: createToken<SystemCalendarBloc>(),
  calendarTemplates: createToken<CalendarTemplateBloc>(),
  calendarTemplateEvents: createToken<CalendarTemplateEventBloc>(),
  companyHolidays: createToken<CompanyHolidayBloc>(),
  customTab: createToken<CustomTabBloc>(),
  eventComments: createToken<EventCommentBloc>(),
  invoiceSchedule: createToken<InvoiceScheduleBloc>(),
  tmInvoiceSchedule: createToken<TMInvoiceScheduleBloc>(),
  tmProviderInvoice: createToken<TMProviderInvoiceBloc>(),
  tmVendorInvoice: createToken<TMVendorInvoiceBloc>(),
  tmGroupNote: createToken<TMGroupNotesBloc>(),
  tmFeeNote: createToken<TMFeeNotesBloc>(),
  tmTemplate: createToken<TMTemplateBloc>(),
  fileForm: createToken<FileFormBloc>(),
  notifications: createToken<NotificationBloc>(),
  rollup: createToken<RollupBloc>(),
  categoryOption: createToken<CategoryOptionBloc>(),
  jobType: createToken<JobTypeBloc>(),
  systemFile: createToken<SystemFileBloc>(),
  commissionOverrides: createToken<CommissionOverrideBloc>(),
  journal: createToken<JournalBloc>(),
  feedback: createToken<FeedbackBloc>(),
  tmProviderInvoiceItem: createToken<TMProviderInvoiceItemBloc>(),
  customerDashboardColumnStatus: createToken<CustomerDashboardColumnStatusBloc>(),
  estimateList: createToken<EstimateListBloc>(),
};
